'use client';

import React, { useEffect, useState } from 'react';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { PrismicDocument } from '@prismicio/types';
import { Content, FilledContentRelationshipField } from '@prismicio/client';
import CardGeneric from 'src/components/Card/CardGeneric';
import Heading from 'src/components/Heading/Heading';
import { Button } from '@get-mosh/msh-shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Routes from 'src/constants/Routes';
import common from 'src/data/common.json';
import styles from './options-cards.module.scss';
import classNames from 'classnames';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

export type OptionsCardsProps = SliceComponentProps<Content.OptionsCardsSlice>;

const OptionCards = ({ slice }: OptionsCardsProps) => {
    const [optionData, setoptionData] = useState<PrismicDocument[]>([]);

    useEffect(() => {
        const init = async () => {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    query: slice.items.map(
                        (item) =>
                            (
                                item.option_card as FilledContentRelationshipField
                            )['id'],
                    ),
                }),
                headers: {
                    'Content-Type': 'application/json',
                    charset: 'utf-8',
                },
            };
            const response = await fetch(
                '/prismic/api/get-type-by-ids',
                requestOptions,
            );
            const data = await response.json();
            return data.results.length && setoptionData(data.results);
        };

        if (slice.items) {
            init();
        }
    }, [slice.items]);

    return (
        <section
            className="py-8 lg:py-16"
            style={{ backgroundColor: slice.primary.background || 'bg-white' }}
        >
            <div className="container">
                <div className="mb-8 block w-full text-center">
                    <Heading
                        centered={true}
                        level={'h2'}
                        className={'px-4 pb-8'}
                    >
                        {slice.primary.title}
                    </Heading>
                    <div
                        className={`${
                            optionData.length < 3
                                ? styles['option_container-custom']
                                : styles['option_container-default']
                        }`}
                    >
                        {optionData &&
                            optionData.length !== 0 &&
                            optionData.map((option) => (
                                <a
                                    key={option.data.id}
                                    className={`${
                                        optionData.length < 3
                                            ? styles['option_cards--custom']
                                            : styles['option_cards']
                                    }`}
                                    href={option.data.cta_path}
                                    title={option.data.cta}
                                >
                                    <CardGeneric
                                        image={{
                                            src: option?.data?.main_image.url,
                                            alt: option?.data?.main_image.alt,
                                            width: option?.data?.main_image
                                                .dimensions?.width,
                                            height: option?.data?.main_image
                                                .dimensions.height,
                                            field: option?.data?.main_image,
                                        }}
                                        className={
                                            'h-full w-full p-4 text-left'
                                        }
                                    >
                                        <div className="flex h-full flex-wrap">
                                            <div className="mb-4 mt-2">
                                                <p className="font-demi text-md">
                                                    {option.data.title}
                                                </p>
                                                <PrismicRichText
                                                    field={
                                                        option.data.description
                                                    }
                                                />
                                                <span className="mb-4 inline-block rounded-full bg-green-light p-2 px-4 font-demi text-sm">
                                                    {option.data.attribute}
                                                </span>
                                                <p>
                                                    <span className="font-demi text-md">
                                                        {option.data.prefix &&
                                                            option.data.prefix +
                                                                ' '}
                                                        {option.data.value}
                                                    </span>
                                                    {option.data.frequency}
                                                </p>
                                            </div>
                                            {option.data.cta && (
                                                <span
                                                    className={classNames(
                                                        'mt-auto inline-flex items-center text-regular text-grey-400 hover:font-demi hover:text-green-dark',
                                                    )}
                                                >
                                                    {option.data.cta}
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}
                                                        className={
                                                            'pl-2 hover:text-green-dark'
                                                        }
                                                    />
                                                </span>
                                            )}
                                        </div>
                                    </CardGeneric>
                                </a>
                            ))}
                    </div>
                </div>
                <div className="text-center">
                    {slice.primary.description && (
                        <div className="pb-4">
                            <PrismicRichText
                                field={slice.primary.description}
                            />
                        </div>
                    )}
                    {slice.primary.cta && (
                        <Button
                            text={slice.primary.cta || common.getStarted}
                            href={slice.primary.cta_path || Routes.QUIZZES}
                            as="a"
                            className={'mb-0'}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};

export default OptionCards;
